// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_42-0";
export var eligibilityCardNotEligible = "_42-1";